import React from 'react';
import { twMerge } from 'tailwind-merge';

type WebUiInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  className?: string;
  inputSize?: 'sm' | 'md' | 'lg';
};

export function WebUiInput({
  className,
  inputSize = 'md',
  ...other
}: WebUiInputProps) {
  const sizeClass = {
    sm: 'text-xs px-1 py-0.5',
    md: 'text-sm px-2 py-1',
    lg: 'text-base px-3 py-2',
  };

  return (
    <input
      className={twMerge('webui-input', sizeClass[inputSize], className)}
      {...other}
    />
  );
}
